// extracted by mini-css-extract-plugin
export default {"priceCaption":"priceCaption__EjQu6"};
    if(module.hot) {
      // 1764953376735
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  